import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var GuardIndicator;
(function (GuardIndicator) {
    GuardIndicator.get = createAccessors(arrayGetSet('guard_indicators'), {
        name: 'Индикатор охраны',
        physical_output: -1,
    });
})(GuardIndicator || (GuardIndicator = {}));
